export default __webpack_public_path__ + "static/media/undraw_feedback_re_urmj.8933db99.svg";